import { XStack, Text } from "tamagui";
import { colors } from "@styles/colors";

interface DetailRowProps {
  label: string;
  value?: string;
  customValue?: React.ReactNode;
  mono?: boolean;
  isLast?: boolean;
}

/** label ── value 的資訊列，用於明細頁的資訊區塊 */
export default function DetailRow({ label, value, customValue, mono, isLast }: DetailRowProps) {
  return (
    <XStack ai="center" jc="space-between" gap="$3" px="$4" py="$3" bbw={isLast ? 0 : 1} bbc={colors.borderLight}>
      <Text fontSize={12} color={colors.sub}>
        {label}
      </Text>
      {customValue ?? (
        <Text fontSize={13} fontWeight="600" color={colors.text} ta="right" fontFamily={mono ? "monospace" : undefined}>
          {value}
        </Text>
      )}
    </XStack>
  );
}
